module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "250",
      "src": "images/logo-nmhm.jpg",
      "width": "192"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "serah",
    staticStyle: {
      "text-align": "center",
      "font-style": "normal"
    }
  }, [_vm._v("ALSO PUBLISHED IN THE SERIES")]), _vm._v(" "), _c('p', {
    staticClass: "seraft",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', [_vm._v("Musical Vitalities: Ventures in a Biotic Aesthetics of Music")])]), _vm._v(" "), _c('p', {
    staticClass: "serau",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Holly Watkins")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aa18a0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-yearsley-0003.vue
// module id = 60
// module chunks = 0